"use client";

import { useTranslations } from "next-intl";

import { EnumModalName } from "@/enums/modal-state";
import IconRecall from "@/icons/recall-phone.svg";
import { useModalStore } from "@/store/modal.store";
import { Button } from "@/ui/Button";
import { cn } from "@/utils/cn";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface CallBackProps extends React.HTMLAttributes<HTMLButtonElement> {}

export const CallBack: React.FC<CallBackProps> = ({ className }) => {
  const t = useTranslations();
  const { openModal } = useModalStore();

  const handleClick = () => {
    openModal(EnumModalName.callBack);
  };

  return (
    <Button
      className={cn("font-bold", className)}
      color="gray"
      variant="bordered"
      radius="sm"
      onPress={handleClick}
    >
      <IconRecall
        width={26}
        height={26}
      />

      <span>{t("Callback request")}</span>
    </Button>
  );
};
